<template>
  <div class="card">
    <div class="card-header header-elements-inline card-header-pointer" data-toggle="collapse" data-target="#cihaz-bilgileri">
      <h5 class="card-title">{{ title }}</h5>
      <div class="header-elements">
        <div v-if="completionRatio" class="px-2 border bg-light rounded text-center d-flex align-items-center">
          <div class="w-100">
            <strong>Tamamlanan: {{ completionRatio }}</strong>
          </div>
        </div>
      </div>
    </div>

    <div id="cihaz-bilgileri" class="card-body show">
      <div class="row">
        <div class="col-md-12 mb-4 d-flex justify-content-between">
          <div v-if="selectable">
            <button v-if="editable" @click="handleAddItem" class="btn btn-labeled btn-labeled-right bg-lagina-primary heading-btn">
              Yeni <b><i class="icon-add"></i></b>
            </button>
            <div class="btn-group mr-2">
              <button type="button" class="btn btn-warning btn-labeled btn-labeled-right dropdown-toggle" data-toggle="dropdown">
                <b><i class="icon-menu7"></i></b>İşlemler
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <button v-if="editable" type="button" class="dropdown-item" @click="handleClearSelectedCheckboxItems">
                  Seçilenleri Sil
                </button>
                <button
                  v-if="productConfig.showAssignedUser"
                  type="button"
                  class="dropdown-item"
                  @click="handleBulkAssignStaff"
                >
                  Personel Ata
                </button>
              </div>
            </div>
          </div>

          <div class="d-flex align-items-start">
            <button
              type="button"
              class="btn btn-success btn-sm btn-labeled btn-labeled-right mr-2"
              @click="handleExport"
            >
              <b><i class="icon-file-excel"></i></b>Dışa Aktar
            </button>
            <div class="d-flex flex-column align-items-center" v-if="editable">
              <div tabindex="500" class="btn btn-secondary btn-file btn-sm">
                <i class="icon-file-plus mr-2"></i>
                <span class="hidden-xs">Dosya Yükle</span>
                <input
                  id="cihaz-bilgileri-file"
                  type="file"
                  name="cihazBilgileriFile[]"
                  accept=".xls,.xlsx"
                  @change="handleFileUpload"
                >
              </div>
              <a href="/downloads/destek-talep-cihaz-bilgileri-import-tr.xlsx" class="mt-2">
                (Örnek Excel)
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 border-1" style="border-color: #e2e2e2">
          <div class="table-responsive">
            <table class="table table-hover plaka-bilgileri-table">
              <thead>
              <tr>
                <th v-for="header in tableHeaders" :key="header.key">
                  <div v-if="header.key === 'checkbox'" class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      @click="handleSelectAll"
                      class="custom-control-input"
                      id="checkbox-select-all"
                      :checked="isAllSelected"
                    >
                    <label class="custom-control-label" for="checkbox-select-all"></label>
                  </div>

                  <span>{{ header.label }}</span>
                </th>
              </tr>
              </thead>

              <tbody>
              <tr
                v-for="(item, index) in localItems"
                :key="item.id || item.temp_id"
                :class="item.temp_id ? '' : (item.service_id ? 'table-success' : 'table-warning')"
              >
                <input type="hidden" :name="`cihazBilgileri[${index}][id]`" :value="item.id || ''" />

                <!-- Checkbox Column -->
                <td v-if="selectable" class="w-10p">
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      @click="(e) => handleCheck(e, item)"
                      class="custom-control-input"
                      :value="item.id"
                      :id="`checkbox-${index}`"
                      :checked="isItemChecked(item)"
                    >
                    <label class="custom-control-label" :for="`checkbox-${index}`"></label>
                  </div>
                </td>

                <!-- Actions Column -->
                <td v-if="editable" class="w-10p">
                  <div class="dropdown">
                    <a href="#" class="btn btn-xs btn-flat bg-slate" data-toggle="dropdown" data-boundary="window" data-placement="right">
                      <i class="icon-arrow-down5"></i>
                    </a>
                    <div class="dropdown-menu">
                      <a v-if="item.service_id"
                         class="dropdown-item"
                         :href="`/service/edit/${item.service_id}`"
                         target="_blank"
                         rel="noopener noreferrer"
                      >
                        Servis Kaydına Git
                      </a>

                      <button v-if="! item.service_id"
                              type="button"
                              @click="(e) => removeItem(item.id || item.temp_id)"
                              class="btn btn-sm btn-danger dropdown-item"
                      >
                        Sil
                      </button>
                    </div>
                  </div>
                </td>

                <!-- Primary Field (Plaka/El Terminali ID) -->
                <td class="primary-field-width">
                    <span class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        v-model="localItems[index][productConfig.primaryField.key]"
                        :name="`cihazBilgileri[${index}][${productConfig.primaryField.name}]`"
                        :readonly="!editable"
                        :placeholder="productConfig.primaryField.label"
                        @input="handlePrimaryFieldInput(index, $event)"
                      />
                    </span>
                </td>

                <!-- City Column - only if needed -->
                <td v-if="productConfig.showCity" class="w-selects">
                  <select
                       :data-city-select="index"
                       class="select2"
                       :name="`cihazBilgileri[${index}][city_id]`"
                       v-model="localItems[index].city.id"
                       @change="updateCity($event, index)"
                     >
                    <option value="">Seçiniz</option>
                    <option v-for="city in citiesArray" :key="city.id" :value="city.id">
                      {{ city.name }}
                    </option>
                  </select>
                </td>

                <!-- District Column - only if needed -->
                <td v-if="productConfig.showDistrict" class="w-selects">
                  <select
                    :data-district-select="index"
                    class="select2"
                    :name="`cihazBilgileri[${index}][district_id]`"
                    :value="getDistrictId(index)"
                    @change="updateDistrict($event, index)"
                  >
                    <option value="">Seçiniz</option>
                    <option v-for="district in getDistrictsForCity(getCityId(index))" :key="district.id" :value="district.id">
                      {{ district.name }}
                    </option>
                  </select>
                </td>

                <!-- İlgili Kişi Column -->
                <td v-if="productConfig.showPerson" class="mw-300">
                  <select
                    :data-person-select="index"
                    class="select2-ajax"
                    data-route="/person/listJson"
                    :name="`cihazBilgileri[${index}][person_id]`"
                    :value="getPersonId(index)"
                    @change="updatePerson($event, index)"
                  >
                    <option value="">Seçiniz</option>
                    <option
                      v-if="localItems[index].person && localItems[index].person.id"
                      :value="localItems[index].person.id"
                      selected
                    >
                      {{ localItems[index].person.name }} - {{ localItems[index].person.phone }}
                    </option>
                  </select>
                </td>

                <!-- Assigned User Column - only if needed -->
                <td v-if="productConfig.showAssignedUser" class="mw-300">
                  <select
                    :data-assigned-user-select="index"
                    class="select2"
                    :name="`cihazBilgileri[${index}][assigned_user_id]`"
                    :value="getAssignedUserId(index)"
                    @change="updateAssignedUser($event, index)"
                  >
                    <option value="">Seçiniz</option>
                    <option v-for="user in users" :key="user.id" :value="user.id">
                      {{ user.name }}
                    </option>
                  </select>
                </td>

                <td v-if="productConfig.showNotes" class="notes-container">
                    <span class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        v-model="localItems[index]['notes']"
                        :name="`cihazBilgileri[${index}][notes]`"
                        placeholder="Notlar"
                      />
                    </span>
                </td>
              </tr>

              <!-- No Data Row -->
              <tr v-if="localItems.length === 0">
                <td :colspan="tableHeaders.length" class="no-data">Veri bulunamadı!</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Silinen ID'leri saklayan input -->
      <input type="hidden" name="cihazBilgileriSilinen" :value="JSON.stringify(deletedItemIds)" />

      <form ref="exportForm" method="POST" action="/support_request/details/cihaz-bilgileri-export" style="display:none">
        <input type="hidden" name="_token" :value="csrfToken">
        <input type="hidden" name="items" :value="exportItemsJson">
      </form>
    </div>

    <div class="modal fade" id="toplu-personel-ata" tabindex="-1">
      <div class="modal-dialog modal-lg" role="dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Toplu Ata</h4>
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
          </div>

          <div class="modal-body">
            <div class="form-group">
              <label>Personel Seçin:</label>
              <select class="select2 form-control" v-model="selectedStaffForBulkAssign">
                <option value="">Seçiniz</option>
                <option v-for="user in users" :key="user.id" :value="user.id">{{ user.name }}</option>
              </select>
            </div>
            <div v-if="checkedItems.length > 0">
              <p>Seçilen Cihazlar ({{ checkedItems.length }}):</p>
              <ul>
                <li v-for="itemId in checkedItems" :key="itemId">
                  {{ getItemDetailsById(itemId) }}
                </li>
              </ul>
            </div>
            <div v-else>
              <p class="text-warning">Lütfen personel atamak için en az bir cihaz seçin!</p>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-info" data-dismiss="modal">Kapat</button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="!selectedStaffForBulkAssign || checkedItems.length === 0"
              @click="applyBulkAssignment"
            >
              Personel Ata
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
  .w-10p {
    width: 10px;
  }

  .primary-field-width {
    width: 250px;
  }

  @media only screen and (max-width: 1444px) {
    .mw-300 {
      max-width:300px
    }

    .w-10p {
      width: 5px;
    }

    .primary-field-width {
      width: 105px;
    }

    .w-selects {
      width:145px;
    }

    .plaka-bilgileri-table td {
      padding: 5px !important;
    }

    .notes-container {
      width: 110px;
    }
  }


</style>
<script>

export default {
  name: 'SimpleTable',
  props: {
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    cities: {
      type: Object,
      required: true
    },
    districts: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      required: false,
    },
    createdByApp: {
      type: String,
      required: false,
      default: null,
    },
    product: {
      type: String,
      required: false,
    },
    completionRatio: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      localItems: [],
      deletedItemIds: [],
      newItemCounter: 0,
      checkedItems: [],
      selectedStaffForBulkAssign: '',
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      exportItemsJson: '',
    }
  },
  created() {
    this.localItems = JSON.parse(JSON.stringify(this.items)).map(item => {
      const baseItemObject = {
        id: item.id || '',
        temp_id: item.temp_id || null,
        service_id: item.service_id || null,
      };

      // Product'a göre primary field ekle
      const primaryFieldKey = this.productConfig.primaryField.key;
      baseItemObject[primaryFieldKey] = item[primaryFieldKey] || '';

      // Conditional fields - sadece gerekirse ekle
      if (this.productConfig.showCity) {
        baseItemObject.city = {
          id: item.city_id || (item.city && item.city.id) || '',
        };
      }

      if (this.productConfig.showDistrict) {
        baseItemObject.district = {
          id: item.district_id || (item.district && item.district.id) || '',
        };
      }

      if (this.productConfig.showPerson) {
        baseItemObject.person = {
          id: item.person_id || (item.person && item.person.id) || '',
          name: item.person && item.person.name ? item.person.name : '',
          phone: item.person && item.person.phone ? item.person.phone : '',
        };
      }

      if (this.productConfig.showAssignedUser) {
        baseItemObject.assigned_user = {
          id: item.assigned_user && item.assigned_user.id ? item.assigned_user.id : '',
        };
      }

      if (this.productConfig.showNotes) {
        baseItemObject['notes'] = item['notes'] || '';
      }

      return baseItemObject;
    });

    if (this.editable && this.localItems.length === 0) {
      setTimeout(() => {
        // Create sayfasında Next Tick'de select2 init geç kalıyor. Bunu engellemek için timeout.
        this.handleAddItem({ preventDefault: () => {} });
      }, 250)
    }
  },
  computed: {
    productConfig() {
      const configs = {
        el_terminali: {
          primaryField: {
            key: 'handheld_terminal_id',
            label: 'El Terminali ID',
            name: 'handheld_terminal_id'
          },
          showCity: false,
          showDistrict: false,
          showPerson: false,
          showAssignedUser: false,
          showNotes: false,
          colSpan: 5
        },
        default: {
          primaryField: {
            key: 'plate',
            label: 'Plaka',
            name: 'plate'
          },
          showCity: true,
          showDistrict: true,
          showPerson: true,
          showAssignedUser: true,
          showNotes: true,
          colSpan: 8
        }
      };

      return configs[this.product] || configs.default;
    },

    // BFY'den gelen talepler düzenlenemez, ancak toplu personel ataması yapılabilir.
    selectable() {
      const isCreatedByBfy = !! this.createdByApp && this.createdByApp.toLowerCase() !== 'crm';

      return this.editable || (isCreatedByBfy && this.productConfig.showAssignedUser);
    },

    tableHeaders() {
      const headers = [
        { key: 'checkbox', label: '', show: this.selectable },
        { key: 'actions', label: '', show: this.editable },
        {
          key: 'primary_field',
          label: this.productConfig.primaryField.label,
          show: true
        }
      ];

      if (this.productConfig.showCity) {
        headers.push({ key: 'city', label: 'İl', show: true });
        headers.push({ key: 'district', label: 'İlçe', show: true });
      }

      if (this.productConfig.showPerson) {
        headers.push({ key: 'person', label: 'İlgili Kişi', show: true });
      }

      if (this.productConfig.showAssignedUser) {
        headers.push({ key: 'assigned_user', label: 'Atanan Personel', show: true });
      }

      if (this.productConfig.showNotes) {
        headers.push({ key: 'notes', label: 'Notlar', show: true });
      }

      return headers.filter(header => header.show);
    },

    isAllSelected() {
      if (this.localItems.length === 0) return false;

      return this.localItems.every(item => {
        const itemId = item.id || item.temp_id;
        return this.checkedItems.includes(itemId);
      });
    },

    citiesArray() {
      return Object.keys(this.cities).map(id => ({
        id: id,
        name: this.cities[id]
      }));
    },

    istanbulCityId() {
      return Object.keys(this.cities).find(id =>
        this.cities[id] === 'İstanbul'
      ) || '';
    },

    defaultCityId() {
      if (this.localItems.length === 0) {
        return this.istanbulCityId;
      } else {
        const lastItem = this.localItems[this.localItems.length - 1];
        return (lastItem.city && lastItem.city.id) || this.istanbulCityId;
      }
    },
  },
  mounted() {
    if (this.localItems.length > 0) {
      setTimeout(() => {
        this.initAllSelect2();
      }, 250);
    }
  },
  methods: {
    getPersonId(index) {
      const item = this.localItems[index];
      if (item && item.person && item.person.id) {
        return item.person.id;
      }
      return '';
    },

    initPersonSelect2(index) {
      const $personSelect = $(`*[data-person-select="${index}"]`);

      const personSelect2Options = {
        ...window.select2OptionsAjax,
        ajax: {
          ...window.select2OptionsAjax.ajax,
          url: '/person/listJson',
        }
      };

      $personSelect.select2(personSelect2Options);

      $personSelect.on('change', (e) => {
        this.updatePerson(e, index);
      });
    },

    updatePerson(event, index) {
      const value = event.target.value;
      const selectedOption = event.target.options[event.target.selectedIndex];
      const selectedText = selectedOption ? selectedOption.text : '';

      if (index >= 0 && index < this.localItems.length) {
        if (!this.localItems[index].person) {
          this.localItems[index].person = { id: '', name: '' };
        }

        this.localItems[index].person.id = value;
        this.localItems[index].person.name = selectedText;
      }
    },

    getDistrictsForCity(cityId) {
      if (!cityId || !this.districts[cityId]) return [];

      return Object.keys(this.districts[cityId]).map(districtId => ({
        id: districtId,
        name: this.districts[cityId][districtId]
      }));
    },

    getDistrictId(index) {
      const item = this.localItems[index];
      if (item && item.district) {
        return item.district.id || '';
      }
      return '';
    },

    handleSelectAll(e) {
      if (e.target.checked) {
        this.checkedItems = this.localItems.map(item => item.id || item.temp_id);
      } else {
        this.checkedItems = [];
      }
    },

    isItemChecked(item) {
      const itemId = item.id || item.temp_id;
      return this.checkedItems.includes(itemId);
    },

    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append('excel_file', file);

      const vm = this;

      $.ajax({
        url: '/support_request/details/cihaz-bilgileri-import',
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        success: function(response) {
          vm.addExcelDataToLocalItems(response.data);
        },
        error: function(xhr) {
          console.error('Excel yükleme hatası:', xhr);
        }
      });
    },

    addExcelDataToLocalItems(excelData) {
      excelData.forEach(item => {
        const tempId = `temp_${this.newItemCounter++}`;

        this.localItems.push({
          id: '',
          temp_id: tempId,
          plate: item.plate || '',
          city: {
            id: item.city?.id || '',
          },
          district: {
            id: item.district?.id || '',
          },
          assigned_user: {
            id: item.assigned_user?.id || '',
          }
        });
      });

      this.$nextTick(() => {
        const startIndex = this.localItems.length - excelData.length;

        for (let i = startIndex; i < this.localItems.length; i++) {
          if (this.productConfig.showCity) {
            const $citySelect = $(`*[data-city-select="${i}"]`);
            $citySelect.select2(window.select2Options || {});
            $citySelect.on('change', (e) => {
              this.updateCity(e, i);
            });
          }

          if (this.productConfig.showDistrict) {
            const $districtSelect = $(`*[data-district-select="${i}"]`);
            $districtSelect.select2(window.select2Options || {});
            $districtSelect.on('change', (e) => {
              this.updateDistrict(e, i);
            });
          }

          if (this.productConfig.showPerson) {
            this.initPersonSelect2(i);
          }

          if (this.productConfig.showAssignedUser) {
            const $userSelect = $(`*[data-assigned-user-select="${i}"]`);
            $userSelect.select2(window.select2Options || {});
            $userSelect.on('change', (e) => {
              this.updateAssignedUser(e, i);
            });
          }
        }
      });
    },

    handleBulkAssignStaff() {
      if (this.checkedItems.length === 0) {
        Lagina.notifyError('Lütfen önce personel atamak istediğiniz cihazları seçin.')
        return;
      }

      $('#toplu-personel-ata').modal('show');

      this.$nextTick(() => {
        $('.modal .select2').on('change', (e) => {
          this.selectedStaffForBulkAssign = e.target.value;
        });
      });
    },

    applyBulkAssignment() {
      if (!this.selectedStaffForBulkAssign) {
        Lagina.notifyError('Lütfen bir personel seçin.')
        return;
      }

      const selectedUserId = this.selectedStaffForBulkAssign;
      const selectedUser = this.users.find(user => user.id == selectedUserId);

      if (!selectedUser) {
        console.error('Seçilen kullanıcı bulunamadı');
        return;
      }

      // Seçili tüm öğelere personel ata
      this.checkedItems.forEach(itemId => {
        const index = this.localItems.findIndex(item =>
          (item.id && item.id === itemId) || (item.temp_id && item.temp_id === itemId)
        );

        if (index !== -1) {
          if (!this.localItems[index].assigned_user) {
            this.localItems[index].assigned_user = {};
          }

          this.localItems[index].assigned_user.id = selectedUserId;

          // Select2'yi güncelle
          this.$nextTick(() => {
            const selectElement = $(`*[data-assigned-user-select="${index}"]`);
            if (selectElement.length) {
              selectElement.val(selectedUserId).trigger('change');
            }
          });
        }
      });

      $('#toplu-personel-ata').modal('hide');

      this.selectedStaffForBulkAssign = '';
    },

    getItemDetailsById(itemId) {
      const item = this.localItems.find(item =>
        (item.id && item.id === itemId) || (item.temp_id && item.temp_id === itemId)
      );

      if (item) {
        const primaryFieldValue = item[this.productConfig.primaryField.key];
        const details = primaryFieldValue ?
          `${this.productConfig.primaryField.label}: ${primaryFieldValue}` :
          '';

        return details || 'Detay bilgisi yok';
      }

      return 'Bulunamadı';
    },

    handleClearSelectedCheckboxItems() {
      const itemsToRemove = [...this.checkedItems];

      itemsToRemove.forEach(itemId => {
        this.removeItem(itemId);
      });

      this.checkedItems = [];
    },

    handleCheck(e, item) {
      const itemId = item.id || item.temp_id;

      if (e.target.checked) {
        if (!this.checkedItems.includes(itemId)) {
          this.checkedItems.push(itemId);
        }
      } else {
        const index = this.checkedItems.indexOf(itemId);
        if (index !== -1) {
          this.checkedItems.splice(index, 1);
        }
      }
    },

    getCityId(index) {
      const item = this.localItems[index];
      if (item && item.city) {
        return item.city.id || '';
      }
      return '';
    },

    updateCity(event, index) {
      const value = event.target.value;

      if (index >= 0 && index < this.localItems.length) {
        if (!this.localItems[index].city) {
          this.localItems[index].city = { id: '' };
        }

        this.localItems[index].city.id = value;

        if (!this.localItems[index].district) {
          this.localItems[index].district = { id: '' };
        }
        this.localItems[index].district.id = '';

        this.$nextTick(() => {
          const districtSelect = $(`*[data-district-select="${index}"]`);
          if (districtSelect.length) {
            districtSelect.val('').trigger('change');
          }
        });
      }
    },

    updateDistrict(event, index) {
      const value = event.target.value;

      if (index >= 0 && index < this.localItems.length) {
        if (!this.localItems[index].district) {
          this.localItems[index].district = { id: '' };
        }

        this.localItems[index].district.id = value;
      }
    },

    getAssignedUserId(index) {
      const item = this.localItems[index];
      if (item && item.assigned_user) {
        return item.assigned_user.id || '';
      }
      return '';
    },

    updateAssignedUser(event, index) {
      const value = event.target.value;

      if (index >= 0 && index < this.localItems.length) {
        if (!this.localItems[index].assigned_user) {
          this.localItems[index].assigned_user = { id: '', name: '' };
        }

        this.localItems[index].assigned_user.id = value;
      }
    },

    handleAddItem(e) {
      e.preventDefault();
      const tempId = `temp_${this.newItemCounter++}`;

      const newItem = {
        id: '',
        temp_id: tempId,
      };

      newItem[this.productConfig.primaryField.key] = '';

      if (this.productConfig.showCity) {
        newItem.city = { id: this.defaultCityId };
        newItem.district = { id: '' };
      }

      if (this.productConfig.showAssignedUser) {
        newItem.assigned_user = { id: '' };
      }

      this.localItems.push(newItem);

      this.$nextTick(() => {
        const index = this.localItems.length - 1;
        this.initSelect2ForItem(index);
      });
    },

    removeItem(itemId) {
      const index = this.localItems.findIndex(item =>
        (item.id && item.id === itemId) || (item.temp_id && item.temp_id === itemId)
      );

      if (index >= 0) {
        const item = this.localItems[index];

        if (item.id && item.id !== '') {
          this.deletedItemIds.push(item.id);
        }

        const checkedIndex = this.checkedItems.indexOf(itemId);
        if (checkedIndex !== -1) {
          this.checkedItems.splice(checkedIndex, 1);
        }

        this.localItems.splice(index, 1);
      }
    },

    initAllSelect2() {
      for (let i = 0; i < this.localItems.length; i++) {
        this.initSelect2ForItem(i);
      }
    },

    initSelect2ForItem(index) {
      if (this.productConfig.showCity) {
        const $citySelect = $(`*[data-city-select="${index}"]`);
        $citySelect.select2(window.select2Options || {});
        $citySelect.on('change', (e) => {
          this.updateCity(e, index);
        });
      }

      if (this.productConfig.showDistrict) {
        const $districtSelect = $(`*[data-district-select="${index}"]`);
        $districtSelect.select2(window.select2Options || {});
        $districtSelect.on('change', (e) => {
          this.updateDistrict(e, index);
        });
      }

      if (this.productConfig.showPerson) {
        this.initPersonSelect2(index);
      }

      if (this.productConfig.showAssignedUser) {
        const $userSelect = $(`*[data-assigned-user-select="${index}"]`);
        $userSelect.select2(window.select2Options || {});
        $userSelect.on('change', (e) => {
          this.updateAssignedUser(e, index);
        });
      }
    },

    handleExport() {
      if (this.localItems.length === 0) {
        Lagina.notifyError('Dışa aktarılacak kayıt bulunamadı.');
        return;
      }

      this.exportItemsJson = JSON.stringify(this.localItems.map(item => {
        const row = {};

        row[this.productConfig.primaryField.label] = item[this.productConfig.primaryField.key] || '';

        if (this.productConfig.showCity) {
          const cityId = item.city && item.city.id;
          row['İl'] = cityId ? (this.cities[cityId] || '') : '';
        }

        if (this.productConfig.showDistrict) {
          const cityId = item.city && item.city.id;
          const districtId = item.district && item.district.id;
          row['İlçe'] = (cityId && districtId && this.districts[cityId])
            ? (this.districts[cityId][districtId] || '')
            : '';
        }

        if (this.productConfig.showPerson) {
          row['İlgili Kişi'] = item.person && item.person.name ? item.person.name : '';
        }

        if (this.productConfig.showAssignedUser) {
          const userId = item.assigned_user && item.assigned_user.id;
          const user = userId ? this.users.find(u => u.id == userId) : null;
          row['Atanan Personel'] = user ? user.name : '';
        }

        if (this.productConfig.showNotes) {
          row['Notlar'] = item.notes || '';
        }

        row['Servis ID'] = item.service_id || '';

        return row;
      }));

      this.$nextTick(() => this.$refs.exportForm.submit());
    },

    handlePrimaryFieldInput(index, event) {
      const isLastRow = index === this.localItems.length - 1;
      const value = event.target.value;

      if (this.editable && isLastRow && value.trim() !== '') {
        this.handleAddItem({ preventDefault: () => {} });
      }
    },
  }
};
</script>
